/**
 * BasicInfoSection - Seção de informações básicas do canal
 *
 * Campos editáveis:
 * - Nome do canal
 *
 * Campos read-only (metadados):
 * - Data de criação
 * - Última atualização
 */

import React from 'react';
import type { UpdateChannelRequest } from '@troia-v3/types';
import type { ChannelResponse } from '@/modules/channels/types';
import { Card, CardHeader, CardContent } from '@/shared/components/ui/Card';
import { Input } from '@/shared/components/ui/Input';
import { Icon } from '@/shared/icons'
interface BasicInfoSectionProps {
  channel: ChannelResponse;
  formData: Partial<UpdateChannelRequest>;
  onFieldChange: (field: keyof UpdateChannelRequest, value: any) => void;
}

export const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  channel,
  formData,
  onFieldChange,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Card>
      <CardHeader className="pb-3 px-4 py-3">
        <div className="flex items-center gap-2">
          <Icon name="info" className="w-4 h-4" style={{ color: 'var(--theme-button-primary)' }} />
          <h3 className="font-bold text-[15px]" style={{ color: 'var(--theme-card-text)' }}>
            Informações Básicas
          </h3>
        </div>
      </CardHeader>

      <CardContent className="px-4 pb-4 space-y-4">
        {/* Nome do Canal */}
        <div>
          <label
            htmlFor="channel-name"
            className="block text-sm font-medium mb-2"
            style={{ color: 'var(--theme-card-text)' }}
          >
            Nome do Canal <span style={{ color: 'var(--theme-error-color)' }}>*</span>
          </label>
          <Input
            id="channel-name"
            type="text"
            value={formData.name || ''}
            onChange={(e) => onFieldChange('name', e.target.value)}
            placeholder="Ex: WhatsApp Suporte"
            className="w-full"
          />
          <p className="text-xs mt-1" style={{ color: 'var(--theme-card-muted)' }}>
            Nome exibido para identificar este canal
          </p>
        </div>

        {/* Metadata */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t" style={{ borderColor: 'var(--theme-card-border)' }}>
          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: 'var(--theme-card-text)' }}
            >
              Criado em
            </label>
            <p className="text-sm" style={{ color: 'var(--theme-card-muted)' }}>
              {formatDate(channel.createdAt)}
            </p>
          </div>
          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: 'var(--theme-card-text)' }}
            >
              Última atualização
            </label>
            <p className="text-sm" style={{ color: 'var(--theme-card-muted)' }}>
              {formatDate(channel.updatedAt)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

BasicInfoSection.displayName = 'BasicInfoSection';
